import { useCallback } from 'react'
import { SubmitButton } from '@panwds/react-form'
import { useFormContext } from 'react-hook-form'


export interface IFormFooterProps {
  buttonText: string,
  dataTestId: string,
}
const FormFooter = (props: IFormFooterProps) => {
  const { buttonText = 'Activate', dataTestId } = props
  const { formState } = useFormContext()
  const { errors = {}, isDirty } = formState
  const isActivateBtnDisabled = useCallback(() => {
    const valid = !Object.keys(errors)?.length
    return !(isDirty && valid)
  }, [errors, isDirty])
  return (
    <div className="cw-flex cw-flex-1 cw-justify-between cw-p-2">
      <div className="cw-flex cw-gap-1">
        <div>
          <SubmitButton
            data-testid={dataTestId}
            disabled={isActivateBtnDisabled()}
          >{buttonText}</SubmitButton>
        </div>
      </div>
    </div>
  )
}
export default FormFooter
